export const setEmploymentDetailsAction = (state = {}, action) => {
  switch (action.type) {
    case "SET_EMPLOYMENT_DETAILS":
      return action.data;

    default:
      return state;
  }
};
